var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialSymbolsCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7167 29C25.1704 29 22.6546 28.4451 20.1694 27.3353C17.6843 26.2256 15.4231 24.6517 13.3861 22.6139C11.3491 20.576 9.77567 18.3149 8.66589 15.8306C7.55611 13.3462 7.00081 10.8304 7 8.28333C7 7.91667 7.12222 7.61111 7.36667 7.36667C7.61111 7.12222 7.91667 7 8.28333 7H13.2333C13.5185 7 13.7731 7.09696 13.9972 7.29089C14.2213 7.48481 14.3537 7.71378 14.3944 7.97778L15.1889 12.2556C15.2296 12.5815 15.2194 12.8565 15.1583 13.0806C15.0972 13.3046 14.9852 13.4981 14.8222 13.6611L11.8583 16.6556C12.2657 17.4093 12.7493 18.1373 13.3091 18.8397C13.8689 19.542 14.4853 20.2196 15.1583 20.8722C15.7898 21.5037 16.4519 22.0896 17.1444 22.6298C17.837 23.17 18.5704 23.6638 19.3444 24.1111L22.2167 21.2389C22.4 21.0556 22.6396 20.9183 22.9353 20.827C23.2311 20.7357 23.5212 20.7101 23.8056 20.75L28.0222 21.6056C28.3074 21.687 28.5417 21.8349 28.725 22.0492C28.9083 22.2635 29 22.5027 29 22.7667V27.7167C29 28.0833 28.8778 28.3889 28.6333 28.6333C28.3889 28.8778 28.0833 29 27.7167 29Z",
    fill: "#37A600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsCall);
export default __webpack_public_path__ + "static/media/material-symbols_call.c7c7b5522a37226f4451268ef57a5e3f.svg";
export { ForwardRef as ReactComponent };